import React, { useEffect, useState } from 'react'
import logo from '../../Assets/logo.svg';
import { Container } from 'react-bootstrap';
import { AiOutlineBars } from "react-icons/ai"
import { IoMdNotificationsOutline } from "react-icons/io"
import "./NavBar.css";

import { Link, useNavigate } from "react-router-dom";
import ProfilNavBar from '../ProfilNavBar/ProfilNavBar';
import NotificationNavbar from '../NotificationNavbar/NotificationNavbar';
import { GoThreeBars } from 'react-icons/go';



function NavBar() {
  const sidebar = document.getElementsByClassName("side-bar");
  const lyt = document.getElementsByClassName('layout-nav-side')
  const [show, setShow] = useState(false);


  const handleClose = () => {
    if (show === false) {
      setShow(true);
    }
    else { setShow(false); }
  }

  useEffect(() => {
    if (show === true) {
      sidebar[0].classList.add("afficher");
      lyt[0].classList.remove("bien22");
    }
    else {
      sidebar[0].classList.remove("afficher");
      lyt[0].classList.add("bien22");
    }
  })



  return (
    <Container fluid expand="lg" className="px-1 d-flex justify-content-between max-hw-100 fixed-top" id='navbar' >

      <div className="d-flex logoNavbar ps-3">
        <Link to=''>
          <img src={logo} alt="" />
        </Link>
        <button className="btnContAffi pb-3" onClick={handleClose}> <GoThreeBars className="btnAffi" /> </button>
      </div>


      <div className="d-flex py-3">
        <NotificationNavbar />
        <ProfilNavBar />
      </div>



    </Container >
  );
};

export default NavBar;
